import * as React from 'react';
import { Search } from '@weddingspot/ws-api-client';

const _styles = require('../venueCard.scss');

interface VenueCardLocation {
    venue: Search.SearchResult;
    isDestinationWeddings?: boolean;
}

const VenueCardLocation = ({ isDestinationWeddings, venue }: VenueCardLocation) => {
    /*'C-' is used in database records for differentiating CI states from others. Therefore, correcting state codes for UI.
    for example: Puerto Rico is PR for United States and C-PR for Caribbean Islands.*/
    let stateAbbr = venue.state_abbr ? `${venue.state_abbr.replace('C-', '')}` : '';
    const COMMA = (venue.city && stateAbbr) ? `, ` : '';
    const PIPE = (venue.city || stateAbbr) ? ` | ` : '';
    return (
        <div className={_styles.locationText}>
            {isDestinationWeddings ? `${venue.region}` : `${venue.city}${COMMA}${stateAbbr}${PIPE}${venue.region}`}
        </div>
    );
};

export default React.memo(VenueCardLocation);
